import { criarParticipante } from '@/uteis/action/tramite/participante'

export const criarDestino = (destinatario) => {
  var tipo = destinatario.tipoDestinatario
  var destino = tipoDestinatario[tipo](destinatario)
  return destino
}

const poderExecutivo = (destinatario) => {
  var destino = criarParticipante(destinatario.descricaoDepartamentoDestinatario, destinatario.idDepartamentoDestinatario, 'ID', destinatario.siglaDepartamentoDestinatario)
  destino.participantePai = criarParticipante(destinatario.descricaoOrgaoDestinatario, destinatario.idOrgaoDestinatario, 'ID', destinatario.siglaOrgaoDestinatario)
  return destino
}

const servidor = (destinatario) => {
  console.log('Destinatário-->', destinatario)
  var destino = criarParticipante(destinatario.nome, destinatario.identificador || destinatario.cpfCnpj || destinatario.nome, 'matricula', destinatario.nome)
  return destino
}

const pessoaFisica = (destinatario) => {
  var destino = criarParticipante(destinatario.nome, destinatario.identificador || destinatario.cpfCnpj || destinatario.nome, 'CPF', destinatario.nome)
  return destino
}

const pessoaJuridica = (destinatario) => {
  var destino = criarParticipante(destinatario.nome, destinatario.identificador || destinatario.cpfCnpj || destinatario.nome, 'CNPJ', destinatario.nome)
  return destino
}

const inscricaoEstadual = (destinatario) => {
  var destino = criarParticipante(destinatario.nome, destinatario.identificador || destinatario.cpfCnpj || destinatario.nome, 'IE', destinatario.nome)
  return destino
}

const tipoDestinatario = {
  PODEREXECUTIVO: poderExecutivo,
  SERVIDOR: servidor,
  PESSOAFISICA: pessoaFisica,
  PESSOAJURIDICA: pessoaJuridica,
  INSCRICAOESTADUAL: inscricaoEstadual
}
